import { render } from "./LiveDataColumn.vue?vue&type=template&id=1d231964"
import script from "./LiveDataColumn.vue?vue&type=script&lang=js"
export * from "./LiveDataColumn.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__